import CreateOrderByExcel from '@/components/custom/pos/CreateOrderByExcel'
import DropoffShippop from '@/components/custom/pos/DropoffShippop'
export default {
    CreateOrderByExcel,
    DropoffShippop   
}